import { render } from "./OfferingPitch.vue?vue&type=template&id=0d2102d7"
import script from "./OfferingPitch.vue?vue&type=script&lang=js"
export * from "./OfferingPitch.vue?vue&type=script&lang=js"
script.render = render

export default script